import { createContext } from 'react'
import { Practitioner } from '@medplum/fhirtypes'
export const ScheduleContext = createContext<{
  selectActivePractitionerProfile: React.Dispatch<React.SetStateAction<string | null>>
  isLoading: boolean
  activePractitionerProfile: Practitioner | null
  listOFPractitioners: Practitioner[]
  isStuffMember: boolean
  selectedMultiplePractitionerIds: string[]
  /**
   * Takes the ids outright, not a `SetStateAction`: the provider persists them to filter storage
   * as it sets them, and an updater form would have to run that write inside a `setState`
   * callback — which React may invoke more than once.
   */
  handleSetSelectedMultiplePractitionerIds: (ids: string[]) => void
} | null>(null)
